import { StyledPropsTheme } from '../../types';
import parent from './standard';

export default Object.assign({}, parent, {
	COLOR_PRIMARY: '#c22000', // 标准色
	COLOR_PRIMARY_LIGHT_O75: 'rgba(194, 32, 0, 0.75)', // 标准色75%透明
	COLOR_PRIMARY_LIGHT_010: 'rgba(194, 32, 0, 0.1)',
	COLOR_PRIMARY_LIGHT: '#f52800', // 标准色淡10%
	INPUT_FOCUS_BORDER_COLOR: 'rgba(194, 32, 0, 0.8)', // 输入框获取焦点后边框色
	TOGGLE_TRUE_BORDER_COLOR: '#c22000',
	TOGGLE_TRUE_BACKGROUND_COLOR: '#c22000'
}) as StyledPropsTheme;
